export { default } from './AccessCode';
